import { Component, OnInit, OnDestroy } from '@angular/core';
import { RouterModule } from '@angular/router';
@Component({
  selector: 'app-floating-window',
  imports: [RouterModule],
  templateUrl: './floating-window.component.html',
  styleUrl: './floating-window.component.css',
})
export class FloatingWindowComponent implements OnInit, OnDestroy {
  private channel = typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel('floating-window') : null;

  private handler = (event: MessageEvent) => {
    if (event.data?.type !== 'FLOATING_UPDATE') return;

    const { width, height, left, top } = event.data.payload;

    if (width && height) {
      window.resizeTo(width, height);
    }

    if (left !== undefined && top !== undefined) {
      window.moveTo(left, top);
    }


  };

  ngOnInit() {
    window.addEventListener('message', this.handler);
    if (this.channel) {
      this.channel.onmessage = (event: MessageEvent) => {
        if (event.data?.type === 'FLOATING_CLOSE_ALL') window.close();
      };
    }
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.handler);
    this.channel?.close();
  }

  close() {
    window.close();
  }
}
